import React from "react";
import { Box, Typography, Button, LinearProgress } from '@mui/material';
import { useTranslation } from "react-i18next";

const VideoUploadForm = ({
  disabledButton,
  formButtonsDisabled,
  isUploading,
  isProcessing,
  screenVideoFile,
  cameraVideoFile,
  uploadSuccess,
  screenButtonText,
  cameraButtonText,
  uploadMessage,
  uploadProgress,
  uploadProgressIndeterminate,
  processingTimeLeft,
  handleScreenVideoChange,
  handleCameraVideoChange,
  handleSendVideos,
  setCommentText,
  noCameraVideo,
  setNoCameraVideo,
  setCameraVideoFile
}) => {
    const [t, i18n] = useTranslation();
        
    return (
        <>
        <Box sx={{ position: "fixed", top: 150, right: 100, bgcolor: "background.paper", p: 2, borderRadius: 2, boxShadow: 3 }}>
            <Box sx={{ position: "fixed", top: 150, right: 100, bgcolor: "background.paper", p: 3, borderRadius: 3, boxShadow: 4, display: "flex", flexDirection: "column", width: 500 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                {t("Самостоятельная загрузка видео")}
            </Typography>
            <label htmlFor="upload-screen-video" style={{ display: "block" }}>
                <Button variant="outlined" component="span" disabled={disabledButton || formButtonsDisabled} fullWidth>
                {t(screenButtonText)}
                </Button>
            </label>
            <input
                id="upload-screen-video"
                type="file"
                accept="video/mp4,video/webm"
                style={{ display: "none" }}
                onChange={handleScreenVideoChange}
                disabled={disabledButton || formButtonsDisabled}
                required
            />
            <label htmlFor="upload-camera-video" style={{ display: "block" }}>
                <Button variant="outlined" component="span" disabled={disabledButton || formButtonsDisabled || noCameraVideo} fullWidth>
                {t(cameraButtonText)}
                </Button>
            </label>
            <input
                id="upload-camera-video"
                type="file"
                accept="video/mp4,video/webm"
                style={{ display: "none" }}
                onChange={handleCameraVideoChange}
                disabled={disabledButton || formButtonsDisabled || noCameraVideo}
                sx={{ fontSize: '1.1rem' }}
            />
            <label htmlFor="no-camera-upload-video">
                <input
                    id="no-camera-upload-video"
                    type="checkbox"
                    checked={noCameraVideo}
                    onChange={() => {
                        setNoCameraVideo(!noCameraVideo);
                        if (!noCameraVideo) {
                            setCameraVideoFile(null);
                        }
                    }}
                    disabled={disabledButton}
                />
                { "  " + t("У меня нет видео с камеры") }
            </label>
            <input
                id="comment-upload-video"
                type="text"
                placeholder={ t("Укажите причину самостоятельной загрузки") }
                onChange={async (event) => {setCommentText(event.target.value)}}
                disabled={disabledButton || formButtonsDisabled}
            />
            <Button
                variant="outlined"
                fullWidth
                onClick={handleSendVideos}
                disabled={disabledButton || formButtonsDisabled || isUploading || isProcessing || !screenVideoFile || uploadSuccess}
            >
                {isUploading ? t("Загрузка...") : isProcessing ? t("Видео в обработке...") : uploadSuccess ? t("Видео загружены") : t("Отправить видео")}
            </Button>

            {isProcessing && (
                <Box sx={{ mt: 1, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>
                    {t("Видео в обработке")}
                </Typography>
                <Typography variant="body2">
                    {t("Предпоказ видео начнется через:")} {processingTimeLeft} {t("сек")}
                </Typography>
                <LinearProgress
                    variant="determinate"
                    value={((60 - processingTimeLeft) / 60) * 100}
                    sx={{ mt: 1 }}
                />
                </Box>
            )}
            {uploadMessage && (
                <Typography role="status" variant="body2" sx={{ mt: 1, color: uploadSuccess ? 'green' : 'warning.main' }}>
                {uploadMessage}
                </Typography>
            )}
            {isUploading && screenVideoFile && cameraVideoFile && (
                <Box sx={{ mt: 1 }}>
                <Typography variant="body2">{t("Прогресс загрузки:")} {uploadProgress}%</Typography>
                <LinearProgress variant={uploadProgressIndeterminate ? "indeterminate" : "determinate"} value={uploadProgress} />
                </Box>
            )}
            </Box>
        </Box>
        </>
    );
};

export default VideoUploadForm;
